import React from 'react';
import cn from 'classname';

import './main.less';

const Switch = props => {

	const { periodSwitch, togglePeriodSwitch }  = props;

	return (
		<div className="top-affiliates-date-switch-container">
			<button
				className={cn({
					'ui-btn': true,
					'top-affiliates-date-switch': true,
					'top-affiliates-date-switch-active': !periodSwitch || periodSwitch === 'day'
				})}
				onClick={togglePeriodSwitch.bind(null, null)}
			>
				Day
			</button>
			<button
				className={cn({
					'ui-btn': true,
					'top-affiliates-date-switch': true,
					'top-affiliates-date-switch-active': periodSwitch === 'week'
				})}
				onClick={togglePeriodSwitch.bind(null, 'week')}
			>
				Week
			</button>
			<button
				className={cn({
					'ui-btn': true,
					'top-affiliates-date-switch': true,
					'top-affiliates-date-switch-active': periodSwitch === 'month'
				})}
				onClick={togglePeriodSwitch.bind(null, 'month')}
			>
				Month
			</button>
		</div>
	);
};

export default Switch;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/top-affiliates/switch/main.js